export default "__VITE_ASSET__xflSN0LD__"